import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { GestionLogisticaContent } from './components/GestionLogisticaContent';

export default function GestionLogistica() {
    return (
        <MainContent
            component={<GestionLogisticaContent />}
            titulo='Autorización logistica'
            noBackground
            tableMaxWidth
        />
    );

};
